import { onBeforeUnmount, onMounted } from 'vue';

/**
 * Runs `handler` on a pointerdown outside every element in `containers`,
 * while `active` is truthy. Registered in the capture phase.
 *
 * @param {import('vue').Ref<boolean>} active
 * @param {Array<import('vue').Ref<HTMLElement|null>>} containers
 * @param {() => void} handler
 */
export function useOutsideClick(active, containers, handler) {
    function onPointerDown(event) {
        if (!active.value) return;
        const target = event.target;
        if (containers.some((containerRef) => containerRef.value?.contains(target))) {
            return;
        }
        handler();
    }

    onMounted(() => {
        document.addEventListener('pointerdown', onPointerDown, true);
    });

    onBeforeUnmount(() => {
        document.removeEventListener('pointerdown', onPointerDown, true);
    });
}
